
import { defineComponent, computed } from 'vue'
import Heading from '@/components/Heading.vue'
import { useStore } from 'vuex'

export default defineComponent(
{
    name: 'Account',
    components:
    {
        Heading
    },
    setup()
    {
        // Load vuex:
        const store = useStore()

        // Computed state params:
        const authenticatedUser = computed(() =>
        {
            return store.getters['auth/getUser']
        })

        // Return data:
        return {
            authenticatedUser
        }
    }
})
